import { render, staticRenderFns } from "./CodeObtain.vue?vue&type=template&id=5c9570b9&scoped=true"
import script from "./CodeObtain.vue?vue&type=script&lang=js"
export * from "./CodeObtain.vue?vue&type=script&lang=js"
import style0 from "./CodeObtain.vue?vue&type=style&index=0&id=5c9570b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9570b9",
  null
  
)

export default component.exports